import 'react-toastify/dist/ReactToastify.css';
import './styles.css';
import moment from 'moment';

import {
  AccessPointWithLocation,
  EngrainMap,
  EngrainMapViewMode,
  GeoLocationPermissionStatus,
} from '@chirp/react-engrain-map';
import delay from 'delay';
import React, { useEffect, useState } from 'react';
import { browserName } from 'react-device-detect';
// import ReactPlayer from 'react-player/lazy';

import { useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { BookedUnit } from '../../../apollo';
import MapIcon from '../../../assets/icons/MapIcon.svg';
// import QrCodeIcon from '../../../assets/icons/qr-code-icon.svg';
// import videoImage from '../../../assets/images/video-icon.png';
import { QRScanner } from '../../../components';
import TapToUnlockDrawer from '../../../components/TapToUnlockDrawer';
import { ENGRAIN_API_KEY } from '../../../config';
import { PropertyMapResponse } from '../../../typing';
import useLocalStorage from '@rehooks/local-storage';

interface SGTProps {
  propertyMap: PropertyMapResponse | null;
  expiresAt?: string | null;
  selectedUnits: BookedUnit[];
}

const SGT: React.FC<SGTProps> = (props) => {
  const userRoleId = useParams().userRoleId as string;
  const { expiresAt, propertyMap, selectedUnits } = props;
  const [viewPropertyMap, setViewPropertyMap] = useState(false);
  const [showQRScanner, setShowQRScanner] = useState(false);
  const [mapLocation, setMapLocation] = useState<AccessPointWithLocation | null>(null);
  const [showUnlockDrawer, setShowUnlockDrawer] = useState(false);
  const [accessPointId, setAccessPointId] = useState<string | null>(null);
  const [
    geoLocationPermissionStatus,
    setGeoLocationPermissionStatus,
  ] = useState<GeoLocationPermissionStatus>(GeoLocationPermissionStatus.UNKNOWN);
  const [finishedMapTutorial, setFinishedMapTutorial] = useLocalStorage<string>('finishedMapTutorial');

  const windowNavigator = navigator as any;
  let browser = browserName === 'Mobile Safari' ? 'Safari' : browserName;

  if (windowNavigator.brave && typeof windowNavigator.brave.isBrave == 'function') {
    browser = 'Brave';
  }

  const expiredAtText = expiresAt ? moment(expiresAt).format('MMM D, h:mma') : null;

  useEffect(() => {
    if (mapLocation) {
      toast.success('Location is updated!');
      setTimeout(() => {
        setMapLocation(null);
      }, 500);
    }
  }, [mapLocation]);

  if (!propertyMap) return null;
  const googleMapsUrl = `https://maps.google.com/?q=${propertyMap.name},${propertyMap.address}`;

  return (
    <>
      {showQRScanner &&
        <QRScanner
          isPropertyMapVisible={viewPropertyMap}
          headerText={expiredAtText || ''}
          headerSubtext="Access Expires"
          onClickBack={() => setShowQRScanner(false)}
          onFinishScanning={async (accessPointId) => {
            setAccessPointId(accessPointId);
            setShowUnlockDrawer(true);
            setShowQRScanner(false);
          }}
        />
      }
      {showUnlockDrawer && accessPointId && expiresAt &&
        <div className="drawer-overlay"
          onClick={(e) => {
            if ((e.target as any).className === 'drawer-overlay') {
              setShowUnlockDrawer(false);
            }
          }}
        >
          <TapToUnlockDrawer
            accessPointId={accessPointId}
            expiresAt={expiresAt}
            onFetchedAccessPoint={async (accessPoint) => {
              const nextMapLocation = accessPoint.mapLocation;
              if (nextMapLocation) {
                await delay(500);
                setMapLocation(nextMapLocation);
              }
            }}
          />
        </div>
      }
      {!viewPropertyMap &&
        <div className="HomePage">
          <span className="HomeTitle">
            Your Guest Pass for {propertyMap?.name} is Activated!
          </span>
          <br />
          <br />
          <br />
          <div className="section1">
            <span className="sectionTitle">how this works:</span>
            {/* <ReactPlayer
              url="https://d1h3bzei7yrici.cloudfront.net/videos/sgt-tour.mp4"
              light={videoImage}
              playing
              controls
              width="342px"
              height="155px"
            /> */}
            <span className="section-body-summary">
              <ol className="how-this-works-list">
                <li><span className="blue-bold">Open the property map below </span>
                to guide you through the property.</li>
                <li><span className="blue-bold">Unlock doors by scanning the QR code </span>
                posted next to an entrance.</li>
                <li><span className="blue-bold">Enable Location Sharing for {browser} </span>
                to see where you are on the map!</li>
              </ol>
            </span>
            <span className="sectionAdditionalTitle">
              You can access entry points until:
            </span>
            <span className="sectionAdditionalContent">{expiredAtText}</span>
            {/* {!!propertyMap &&
              <button
                onClick={() => setShowQRScanner(true)}
                className="sectionAdditionalButton"
              >
                <img alt="" src={QrCodeIcon} /> Scan the QR Code
              </button>
            } */}
          </div>
          <div className="sectionBottom">
            <span className="sectionTitle">Map out your tour:</span>
            <span className="sectionBody">
              Our interactive map includes a built-in QR scanner to unlock doors and drop your current location on the map!
            </span>
            <button
              onClick={() => setViewPropertyMap(true)}
              className="sectionAdditionalButton"
            >
              <img alt="" src={MapIcon} /> View Property Map
            </button>
            {propertyMap.address &&
              <>
                <span className="sectionTitle">Get Driving Directions</span>
                <a
                  href={googleMapsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="LinkClassHome"
                >
                  {propertyMap.address}
                </a>
              </>
            }
          </div>
          <div className="additional-padding"></div>
        </div>
      }
      {!!propertyMap && viewPropertyMap &&
        <>
          <div className="map-container">
            <EngrainMap
              propertyName={propertyMap.name}
              viewMode={EngrainMapViewMode.VIEW}
              mapId={propertyMap.externalMapId}
              apiKey={ENGRAIN_API_KEY}
              floorsData={propertyMap.externalFloors}
              unitsData={propertyMap.externalUnits}
              // bookedUnitIds={selectedUnits}
              bookedUnits={selectedUnits}
              unitColor={'#687987'}
              selectedUnitColor={'#0076CC'}
              promptTutorial={finishedMapTutorial !== userRoleId}
              onFinishedTutorial={() => {
                setFinishedMapTutorial(userRoleId)
              }}
              onApprovedLocationStatus={(status) => setGeoLocationPermissionStatus(status)}
              geoLocationPermissionStatus={geoLocationPermissionStatus}
              toggleBackButton={() => setViewPropertyMap(false)}
              toggleQrScanner={() => setShowQRScanner(true)}
              onError={(errorMessage: string) => {
                toast.error(errorMessage);
              }}
              zoomToLocation={mapLocation}
              accessPoints={[]}
            />
          </div>
        </>
      }
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
      />
    </>
  );
};

export default SGT;
